import { ImageDocument, ImageUpload } from "@/api/dtos";
import { Box, Button, Dialog, DialogContent, DialogContentText, DialogTitle, Paper, styled, Typography } from "@mui/material";
import { FC, useContext, useMemo } from "react";
import MriImageUploadsContext from "../../hooks/context/MriImageUploadsContext";

const StyledButtonGroup = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2, 2, 2, 2),
    textAlign: 'center',
    gap: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-end',
}))

const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
    padding: theme.spacing(2),

    '&>p': {
        padding: theme.spacing(0),
        fontSize: '1.25rem',
        fontWeight: 500
    }
}))

const StyledDialogContent = styled(DialogContent)(({theme}) => ({
    padding: theme.spacing(0, 0),
    overflow: 'visible',

    '&>p': {
        padding: `${theme.spacing(0, 2, 2, 2)} !important`,
    }
}));

interface VerifyDialogProps {
    verifyId: number | undefined;
    verifyAreYouSureOpen: boolean;
    onVerifyAreYouSureClose: () => void;
    onVerifyAreYouSureConfirm: () => void;
}


const VerifyDialog: FC<VerifyDialogProps> = ({
    verifyId,
    verifyAreYouSureOpen,
    onVerifyAreYouSureClose,
    onVerifyAreYouSureConfirm
}) => {

    const { data: mriImageUploads} = useContext(MriImageUploadsContext);

    const imageUpload: ImageUpload | undefined = useMemo(() => {
        if (verifyId && mriImageUploads) {
            return mriImageUploads.find((x: ImageUpload) =>
                x.mriDocuments?.some(d => d.id === verifyId)
            );
        }
        return undefined;
    }, [verifyId, mriImageUploads]);

    const document: ImageDocument | undefined = useMemo(() => {
        if (verifyId && imageUpload) {
            return imageUpload.mriDocuments?.find(d => d.id === verifyId);
        }
        return undefined;
    }, [verifyId, imageUpload]);

    return <>
        <Dialog
            open={verifyAreYouSureOpen === true}
            onClose={onVerifyAreYouSureClose}
            aria-labelledby="start-dialog-title"
            aria-describedby="start-dialog-description"
            maxWidth="xs"
            fullWidth
        >
            <Paper>
                <StyledDialogTitle id="start-dialog-title">
                    <Typography
                        color="secondary"
                    >
                        Verify Upload
                    </Typography>
                </StyledDialogTitle>
                <StyledDialogContent>
                    <DialogContentText id="create-dialog-description">
                        "{document?.name}" for participant {imageUpload?.participantNumber}
                    </DialogContentText>

                    <DialogContentText id="create-dialog-description">
                        Are you sure you want to verify this upload? The upload will no longer be editable.
                    </DialogContentText>

                    <DialogContentText id="create-dialog-description">
                        <i>This action cannot be undone.</i>
                    </DialogContentText>

                    <StyledButtonGroup>
                        <Button
                            color="secondary"
                            onClick={onVerifyAreYouSureClose}
                        >
                            Cancel
                        </Button>
                        <Button
                            color="primary"
                            variant="contained"
                            onClick={onVerifyAreYouSureConfirm}
                        >
                            Verify
                        </Button>
                    </StyledButtonGroup>

                </StyledDialogContent>
            </Paper>
        </Dialog>
    </>
}

export default VerifyDialog;